const GA_CATEGORY_NAME = 'In-context';

const inContextEvents = {
  popupInContextDisplayed: {
    eventName: 'Popup - In-context displayed',
    /**
     *
     * @param {number} numberOfQuestions
     * @returns {object}
     */
    getMetaData: (numberOfQuestions) => ({
      'Number of Questions': numberOfQuestions,
    }),
  },
};

export {
  GA_CATEGORY_NAME,
};

export default inContextEvents;
